import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetRolesPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/inputs/get-roles-paginated.form-validation';
import { GetRolesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/inputs/get-roles-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { CustomerFilterController } from '@app/feature/customer/customer-filter/customer-filter.controller';
import { NetworkFilterController } from '@app/feature/network/network-filter/network-filter.controller';

const RoleListFilterFormStep1CustomerIdFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetRolesPaginatedModel>();
  const { customerId } = useGetRolesPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <>
      <Controller
        name="customerId"
        control={control}
        rules={customerId}
        render={({ field /* , fieldState: { error } */ }) => {
          const values = [];

          if (Array.isArray(field.value)) {
            values.push(...field.value);
          } else if (field.value) {
            values.push(field.value);
          }

          return (
            <CustomerFilterController
              selectedItemIds={values}
              onChange={(value) => field.onChange(value)}
            />
          );
        }}
      />
      <Divider />
    </>
  );
};

const RoleListFilterFormStep1NetworkIdFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetRolesPaginatedModel>();
  const { customerId } = useGetRolesPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Controller
      name="networkId"
      control={control}
      rules={customerId}
      render={({ field /* , fieldState: { error } */ }) => {
        const values = [];

        if (Array.isArray(field.value)) {
          values.push(...field.value);
        } else if (field.value) {
          values.push(field.value);
        }

        return (
          <NetworkFilterController
            selectedItemIds={values}
            onChange={(value) => field.onChange(value)}
          />
        );
      }}
    />
  );
};

export const RoleListFilterFormStep1Controller = (): React.JSX.Element => {
  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <Stack
      direction="row"
      justifyContent="stretch"
      alignItems="stretch"
      flex={1}
      gap={GapEnum.M}>
      <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.M}>
        <RoleListFilterFormStep1CustomerIdFragment />
        <RoleListFilterFormStep1NetworkIdFragment />
      </Stack>
    </Stack>
  );
};
